<template>
    <v-app id="app">
        <router-view></router-view>
        <v-snackbar top multi-line v-model="snackbar" :color="snackbarColor">{{ snackbarText }}
            <v-btn dark flat @click="snackbar=false">Close</v-btn>
        </v-snackbar>
    </v-app>
</template>



<script>
    export default {
        props: ['action'],
        data: () => ({}),
        computed: {
            snackbar:{
                get: function () {
                    return this.$store.state.utility.snackbar;
                },
                set: function(value) {
                    this.$store.state.utility.snackbar = value
                    return value
                }
            },
            snackbarText: function () {
                return this.$store.state.utility.snackbarText;
            },
            snackbarColor: function () {
                return this.$store.state.utility.snackbarColor;
            }
        },
        methods: {
            snackbarClose: function() {

            }
        },
        created: function () {
/*            let this_ = this
            this.$store.dispatch('checkLogin', {}).then(function (response) {
                this_.response = response
                if (response.status !== 200) this_.$store.dispatch('processError', this_.response)
                if (this_.response.status === 200) {
                    this_.$router.push('/home')
                }
            })*/
        }
    }
</script>
